import axios from "axios";
import store from "@/store";
import { router } from "@/router";

export const api1 = axios.create({
  baseURL: process.env.VUE_APP_API1_URL,
});

export const api2 = axios.create({
  baseURL: process.env.VUE_APP_API2_URL,
});

export const api3 = axios.create({
  baseURL: process.env.VUE_APP_API3_URL,
});

export const apiEmail = axios.create({
  baseURL: process.env.VUE_APP_EMAIL_URL,
});


// 👇 Solo string, sin axios
export const AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE;

// 👇 Igual que antes, string para SockJS
export const WEBSOCKET_CHAT_URL = process.env.VUE_APP_WEBSOCKETCHAT_URL;
export const WEBSOCKET_PROJECT_URL = process.env.VUE_APP_WEBSOCKETPROJECT_URL;

const attachAuth = (config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.accessToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${user.accessToken}`;
  }
  return config;
};

const handleError = (error) => {
  if (error.response) {
    const status = error.response.status;
    if (status === 401 || status === 403) {
      store.dispatch("auth/logout");
      router.push("/login");
    }
  }
  return Promise.reject(error);
};

[api1, api2, api3, apiEmail].forEach((api) => {
  api.interceptors.request.use(attachAuth, (e) => Promise.reject(e));
  api.interceptors.response.use((r) => r, handleError);
});


